import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { notifyUser } from "../utils/notifyUser";

const ResetPassword = () => {
    const [email, setEmail] = useState("");
    const [tempPassword, setTempPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleReset = async () => {
        if(!email || !tempPassword || !newPassword || !confirmPassword) {
            return notifyUser(null, "error", "Please fill in all fields", "toast", null, null, null, null, null, false, false, "top-center");
        }

        if(newPassword !== confirmPassword) {
            return notifyUser(null, "error", "New passwords do not match", "toast", null, null, null, null, null, false, false, "top-center");
        }

        setLoading(true);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/resetpassword`,
                {
                    email,
                    tempPassword,
                    newPassword,
                },
            );
            notifyUser(null, "success", res.data.message, "toast", null, null, null, null, null, false, false, "top-center");
            setTimeout(() => {
                navigate("/login");
            }, 1500);
        } catch(err) {
            notifyUser(null, "error", err.response?.data?.error || "Failed to reset password", "toast", null, null, null, null, null, false, false, "top-center");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
            <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
                <h2 className="text-2xl font-bold mb-6 text-center text-navy">
                    Reset Password
                </h2>

                <label className="block mb-2 font-medium">Email</label>
                <input
                    type="email"
                    className="w-full border px-4 py-2 rounded mb-4"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                />

                <label className="block mb-2 font-medium">
                    Temporary Password
                </label>
                <input
                    type="password"
                    className="w-full border px-4 py-2 rounded mb-4"
                    value={tempPassword}
                    onChange={(e) => setTempPassword(e.target.value)}
                    placeholder="Temporary password"
                />

                <label className="block mb-2 font-medium">New Password</label>
                <input
                    type="password"
                    className="w-full border px-4 py-2 rounded mb-4"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="New password"
                />

                <label className="block mb-2 font-medium">
                    Confirm New Password
                </label>
                <input
                    type="password"
                    className="w-full border px-4 py-2 rounded mb-6"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                />

                <button
                    onClick={handleReset}
                    className="w-full bg-navy text-white py-2 rounded hover:bg-[#063d5d]"
                    disabled={loading}
                >
                    {loading ? "Resetting..." : "Reset Password"}
                </button>
            </div>
        </div>
    );
};

export default ResetPassword;
